module.exports = __webpack_public_path__ + "static/img/73040B_2_3_R_20200612_LC.8ec86fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/73040B_2_3_R_20200612_LC.png
// module id = u0l0
// module chunks = 0